import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=06c82e50&scoped=true"
import script from "./RequestDialog.vue?vue&type=script&lang=ts"
export * from "./RequestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c82e50",
  null
  
)

export default component.exports